import { useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { getQueryObject, logException } from 'Utils';
import ProgressBar from 'Components/ProgressBar';

const SocialToken = (props) => {
  const loginWithSocialToken = async (
    provider,
    {
      accessToken,
      code,
      original_client_id,
      original_redirect_uri,
      profileValues,
    }
  ) => {
    try {
      const parameters = {
        accessToken,
        code,
        original_client_id,
        original_redirect_uri,
        profileValues,
      };

      await props.uim.uimApi.socialLogin(provider, parameters);
    } catch (err) {
      logException(err);
      props.failureMessage(err.message.toString());
    }
  };

  const decryptUserData = async (encryptedData) => {
    if (!encryptedData) return null;

    const payload = {
      data: encryptedData,
      date: new Date().toISOString(),
    };
    const axiosConfig = {
      data: payload,
      method: 'post',
      timeout: 10000,
      url: '/api/v1/ping',
    };
    const response = await axios(axiosConfig);
    if (response.status !== 200) return null;

    return response.data;
  };

  const login = async () => {
    const {
      access_token: accessToken,
      auth_code: code,
      data,
      original_client_id,
      original_redirect_uri,
      provider,
    } = getQueryObject(props);

    if (!(provider && (code || accessToken))) {
      // console.log('Missing parameters! Redirecting...');
      return props.history.push('/');
    }

    const userData = await decryptUserData(data);
    loginWithSocialToken(provider, {
      accessToken,
      code,
      original_client_id,
      original_redirect_uri,
      profileValues: userData,
    });
  };

  useEffect(() => {
    if (props.isUimLoaded) login();
  }, [props.isUimLoaded]);

  return <ProgressBar />;
};

SocialToken.propTypes = {
  failureMessage: PropTypes.func.isRequired,
  isUimLoaded: PropTypes.bool.isRequired,
  uim: PropTypes.object.isRequired,
};

export default SocialToken;
